import React from 'react';

import { range } from '@/utils';
import styles from './PrideFlag.module.css';
import { COLORS } from './constants';

function PrideFlag({
  variant = 'rainbow',
  numOfColumns = 10,
  billow = 8,
  shouldStaggerBillow = false,
  staggeredDelay = 100,
  radiusOverride = undefined,
  className = '',
  ...delegated
}) {
  const colors = COLORS[variant];

  const animationDuration = 500 + numOfColumns * 10;

  const background = generateGradientString(colors);

  return (
    <div className={`${styles.wrapper} ${className}`} {...delegated}>
      {range(numOfColumns).map((chunkIndex) => (
        <div
          key={chunkIndex}
          className={styles.column}
          style={{
            '--billow': shouldStaggerBillow
              ? chunkIndex * billow + 'px'
              : billow + '%',
            animationDuration: animationDuration + 'ms',
            animationDelay:
              numOfColumns * staggeredDelay * -1 +
              chunkIndex * staggeredDelay +
              'ms',
            background,
            borderRadius: radiusOverride,
            // Used for default position when motion is disabled:
            '--sin': chunkIndex * 45 + 'deg',
          }}
        />
      ))}
    </div>
  );
}

function generateGradientString(colors) {
  const numOfColors = colors.length;
  const segmentHeight = 100 / numOfColors;

  const gradientStops = colors.map((color, index) => {
    const from = index * segmentHeight;
    const to = (index + 1) * segmentHeight;

    return `${color} ${from}%, ${color} ${to}%`;
  });

  return `linear-gradient(to bottom, ${gradientStops.join(', ')})`;
}

export default PrideFlag;
